<template>
	<ImageTrioShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import ImageTrioShell from '../shared/ImageTrioShell.vue';
	import { imageBlockEmits, imageBlockProps } from '../shared/imageBlockProps.js';

	export default {
		name: 'GBlockImageTrio',
		components: { ImageTrioShell },
		props: imageBlockProps,
		emits: imageBlockEmits,
	};
</script>
